import { useMutation, useQuery } from "@tanstack/react-query";

import { Button, Popconfirm, Table, Tag, Typography, message } from "antd";

import AddSubscription from "../components/Add/Subscription";
import AddTo from "../components/Add/subs/AddTo";
import useSearch from "../components/Search";
import { deleteSubscription, getAllSubscriptions } from "../utils/api";
import { useAuth } from "../utils/store";

const Subscription = () => {
  const user = useAuth((state) => state.user);
  const [messageApi, contextHolder] = message.useMessage();
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["subscriptions"],
    queryFn: async () => await getAllSubscriptions(),
  });

  const search = useSearch();

  const { mutate, isLoading: isLoading2 } = useMutation(
    async (values) => await deleteSubscription(values),
    {
      onSuccess: () => {
        messageApi.success(`Deleted`);
        refetch();
      },
    }
  );

  console.log(data);

  const columns = [
    {
      title: "S.no",
      dataIndex: "sno",

      render(value, record, index) {
        return index + 1;
      },
    },
    {
      title: "Actions",
      dataIndex: "action",
      render(value, record) {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 10,
            }}
          >
            <AddTo row={record} refetch={refetch} />
            <AddSubscription update={record} refech={refetch} />

            <Popconfirm
              title="Delete the task"
              description="Are you sure to delete this task?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => mutate(record._id)}
            >
              <Button danger loading={isLoading2}>
                Delete
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },

    {
      title: "Name",
      dataIndex: "name",
      ...search("name"),
    },
    {
      title: "Price",
      dataIndex: "price",
    },
    {
      title: "Validity",
      dataIndex: "validity",
    },
    {
      title: "Reward",
      dataIndex: "isReward",
      render(value) {
        return (
          <Tag color={value ? "green" : "red"}>{value ? "Yes" : "No"}</Tag>
        );
      },
    },
    {
      title: "Music Reward Coin",
      dataIndex: "musicRewardCoin",
    },
    {
      title: "Video Reward Coin",
      dataIndex: "videoRewardCoin",
    },
  ];
  return (
    <div
      style={{
        padding: 24,
      }}
    >
      {contextHolder}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <Typography style={{ fontSize: 20, fontWeight: 600, marginBottom: 10 }}>
          Subscription
        </Typography>
        <AddSubscription refech={refetch} />
      </div>
      <Table columns={columns} dataSource={data} loading={isLoading} />
    </div>
  );
};

export default Subscription;
